import styled from 'styled-components'

const hasKitSet = parentSku => (parentSku ? 'grid-template-columns: 1fr;' : '')

export const LRContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  box-sizing: border-box;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  min-width: 0;
  min-height: 0;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 1000px;
  padding: 16px;
`

export const LRHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  > div {
    display: grid;
    grid-template-columns: 1fr;

    span {
      color: #333333;
      font-size: 14px;
      font-family: 'Roboto';
      font-weight: normal;
      line-height: 21px;
    }
  }

  > div:last-child {
    text-align: end;
  }


  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;

    > div:last-child {
      text-align: start;
    }
  }
`

export const LRItemSection = styled.div`
  > div {
    background: #ffffff;
    border: 1px solid #cccaca;
    border-radius: 6px;
    padding: 16px 24px;
    > div {
      grid-template-columns: 90px 1fr;
      display: grid;
      column-gap: 20px;
      align-items: start;

      > div {
        > span {
          :first-child {
            font-weight: 700;
          }

          display: block;
          color: #333333;
          font-family: 'Roboto';
          font-size: 16px;
          font-weight: normal;
          letter-spacing: 0px;
          line-height: 28px;
        }
      }

      @media only screen and (max-width: 768px) {
        > div {
          > span {
            font-size: 14px;
          }
        }
      }

      :last-child {
        margin-top: 10px;

        > div:last-child {
          max-width: 440px;
        }

        @media only screen and (max-width: 768px) {
          ${({ parentSku }) => hasKitSet(parentSku)}

          > div:last-child {
            max-width: 100%;
          }
        }
      }
    }
  }
`

export const LRRefund = styled.div`
  text-align: center;
  padding: 35px 0px;

  > span {
    width: 282px;
    height: 32px;
    color: #333333;
    font-size: 24px;
    font-family: 'Roboto';
    font-weight: normal;
    text-align: center;
    letter-spacing: 0px;
    line-height: 32px;
    > span {
      font-weight: bold;
    }

    @media only screen and (max-width: 768px) {
      font-size: 20px;
    }
  }
`
